import styled from 'styled-components'

export const StyledOutlineButton = styled.button`
  --button-color: hsla(0, 0%, 13%, 1);
  --border-color: hsla(109, 0%, 77%, 1);
  --hover-color: hsla(109, 0%, 96%, 1);

  &.primary {
    --button-color: hsla(210, 77%, 47%, 1);
    --border-color: var(--button-color);
    --hover-color: hsla(205, 63%, 98%, 1);
  }
  &.secondary {
    --button-color: hsla(339, 100%, 43%, 1);
    --border-color: var(--button-color);
    --hover-color: hsla(340, 81%, 98%, 1);
  }

  background-color: var(--color-white);
  border-radius: 4px;
  border: 1px solid var(--border-color);
  color: var(--button-color);
  font-size: 0.75rem;
  letter-spacing: 0.02857rem;
  line-height: 1.75;
  min-width: 64px;
  padding: 0.3125rem 1rem;
  text-transform: uppercase;
  transition: background-color 225ms ease-in-out;

  &:hover,
  &:focus {
    background-color: var(--hover-color);
  }

  &:hover {
    cursor: pointer;
  }
`

const StyledButton = styled.button`
  --bg: linear-gradient(
    to bottom,
    var(--color-blue-700) 0%,
    var(--color-blue-400) 100%
  );
  --bg-hover: linear-gradient(
    to bottom,
    var(--color-blue-400) 0%,
    var(--color-blue-400) 100%
  );

  &.btn-secondary {
    --bg: linear-gradient(to bottom, #f87f3f 0%, #d33b2c 100%);
    --bg-hover: linear-gradient(to bottom, #d33a2c 0%, #d33a2c 100%);
  }

  &.btn-tertiary {
    --bg: linear-gradient(to bottom, #9dc14c 0%, #43b24f 100%);
    --bg-hover: linear-gradient(to bottom, #43b24f 0%, #43b24f 100%);
  }

  background: var(--bg);
  border-radius: 2.25rem;
  border: 0;
  color: var(--color-white);
  display: block;
  margin-bottom: 1.5rem;
  max-width: 360px;
  padding: 0.75rem 3rem;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.25);
  transition: background 225ms ease-in-out;

  &:hover,
  &:focus {
    background: var(--bg-hover);
  }

  &:hover {
    cursor: pointer;
  }
`

export default StyledButton
